import React from 'react';
import { StaticPageHeader } from '../components/StaticPageHeader';
import { Footer } from '../components/Footer';

export const Disclaimer = () => {
  return (
    <div className="min-h-screen bg-white">
      <StaticPageHeader />
      
      {/* Add padding top to account for fixed header */}
      <div className="pt-16">
        {/* Content */}
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Disclaimer</h1>
          <p className="text-gray-600 mb-8">Effective Date: July 1, 2026</p>

          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 mb-6">
              DriveHR provides HR-related templates, documents, and tools for informational purposes only.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">1. No Legal Advice</h2>
            <p className="text-gray-700 mb-6">
              DriveHR is not a law firm and does not offer legal, tax, or compliance advice. Our resources are educational and should not replace consultation with a qualified legal or HR professional.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">2. Use at Your Own Risk</h2>
            <p className="text-gray-700 mb-4">
              While we aim to provide accurate and up-to-date content, we make no warranties regarding completeness or suitability for your specific situation.
            </p>
            <p className="text-gray-700 mb-6">
              Laws and regulations vary by jurisdiction and change over time. It is your responsibility to confirm that any template, policy, or practice complies with the laws applicable to your business and location.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">3. Limitation of Liability</h2>
            <p className="text-gray-700 mb-6">
              DriveHR is not liable for any actions taken or not taken based on our materials. Users assume full responsibility for decisions made using our resources.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">4. Consult Your Attorney</h2>
            <p className="text-gray-700 mb-6">
              Before implementing any templates, policies, or practices, you should consult with your legal counsel.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">5. Contact</h2>
            <p className="text-gray-700 mb-6">
              Questions? Email <a href="mailto:help@drive-hr.com" className="text-blue-600 hover:underline">help@drive-hr.com</a>.
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};